"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    checkStatusObject: function() {
        return checkStatusObject;
    },
    getReasonIndex: function() {
        return getReasonIndex;
    },
    getStatus: function() {
        return getStatus;
    },
    getStatusCode: function() {
        return getStatusCode;
    },
    getStatusCodes: function() {
        return getStatusCodes;
    },
    getStatusDescription: function() {
        return getStatusDescription;
    },
    getStatusIndex: function() {
        return getStatusIndex;
    }
});
const _enums = require("../../enums");
const getStatus = (statusCode)=>{
    const status = _enums.statusCodes.find((status)=>status.code === statusCode);
    return status ? status : null;
};
const getStatusDescription = (statusCode)=>{
    const status = _enums.statusCodes.find((status)=>status.code === statusCode);
    return status ? status.description : "Invalid status code";
};
const getStatusCode = (statusDescription)=>{
    const status = _enums.statusCodes.find((status)=>status.description === statusDescription);
    return status ? status.code : -1;
};
const checkStatusObject = (status = {})=>{
    const { code = 0 } = status;
    const validStatus = _enums.statusCodes.find((statusObj)=>statusObj.code === code);
    return validStatus;
};
const getStatusCodes = (code)=>{
    if (code != null && code >= 0 && code <= 4) {
        return _enums.statusCodes.filter((statusCode)=>{
            return Math.floor(statusCode.code / 100) === code;
        });
    }
    // return all
    return _enums.statusCodes;
};
const getStatusIndex = (code = 0)=>{
    return Math.floor(code / 100);
};
const getReasonIndex = (code = 0)=>{
    return code % 100;
};
